module.exports = __webpack_public_path__ + "img/低.b884e3a5.svg";